import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { FormGroup,FormControl, FormArray,Validators } from "@angular/forms";
import { Router } from "@angular/router";


@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})

export class SignUpComponent implements OnInit {

formAdmin: any;
userData:any;

  constructor(
    public authService: AuthService,
    public router: Router, 
  ) { 
    this.formAdmin = new FormGroup({
      proyecto: new FormControl(""),
      email: new FormControl(""),
      password: new FormControl(""),
	  telefono:new FormControl(""),
	  status:new FormControl(false),
	  rol:new FormControl("admin"),
	  
    })
  }

  ngOnInit() { }

  onSubmit(dataAdmin:any){
    console.log(dataAdmin);

    this.authService.postRegistro(dataAdmin)
        .subscribe (res=>{
        
          if (res) {
            this.userData = res;
			let qr = this.userData.body.body;
			console.log (qr);
            //localStorage.setItem('sfeJfsld8dsKld5lRld', this.userData.token);
			alert ('Usuario creado')
			this.formAdmin.reset()
			this.router.navigate(['verify-sms'],{queryParams:[qr]});
            //this.router.navigate(['listadoProf']);
            //JSON.parse(localStorage.getItem('sfeJfsld8dsKld5lRld'));
          } else {
            localStorage.setItem('sfeJfsld8dsKld5lRld', "null");
			this.formAdmin.reset()            //JSON.parse(localStorage.getItem('sfeJfsld8dsKld5lRld'));
          }
        });   
  }
 
  
 
}
